import { TrashCan } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const LiveStreamFbOutputsRemoveDialog = makeConfirmActionDialog({
  mutationName: "liveStreamFbOutputsRemove",
  action: "Remove Facebook Output",
  paramName: "liveStreamFbOutputIds",
  useButtonProps: () => {
    return {
      icon: <TrashCan />,
      content: "Remove",
    };
  },
});
